import { render, staticRenderFns } from "./UserFollowers.vue?vue&type=template&id=407a38ed&"
import script from "./UserFollowers.vue?vue&type=script&lang=js&"
export * from "./UserFollowers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports